export default "__VITE_ASSET__BzKGfEeP__"